import { Component, OnInit } from '@angular/core';
import { YouthWorkerModel } from 'src/app/models/youth-workers.model';
import { StudentPortalService } from 'src/app/services/student-portal.service';

@Component({
  selector: 'app-youth-worker-profile-view',
  templateUrl: './youth-worker-profile-view.component.html',
  styleUrls: ['./youth-worker-profile-view.component.scss', './staff-profile.scss']
})
export class YouthWorkerProfileViewComponent implements OnInit {

  onLeaveStatus: boolean = true;
  youthWorkers: YouthWorkerModel;

  constructor(private _studentPortal: StudentPortalService) {}

  ngOnInit(): void {
    this._studentPortal.getYouthWorkers().subscribe(data => {
      this.youthWorkers = data;
      //console.log("Youth worker data: ", this.youthWorkers);
    })
  }

}
